import { type FC, useMemo } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Link } from '@vakantiesnl/components/src/atoms/Link';
import { type Nbc, type Reviews, type Search } from '@vakantiesnl/types';

import { useCustomStyles } from './ReportButton.style';

type ReportButtonProps = {
	title?: string;
	iconOnly?: boolean;
} & (
	| {
			type: 'review';
			review: Reviews.FormattedReview;
			accommodation?: Search.CompactAccommodationItem;
	  }
	| {
			type: 'image';
			image: Nbc.Image;
			accommodation?: Search.CompactAccommodationItem;
	  }
);

export const ReportButton: FC<ReportButtonProps> = ({ title, iconOnly, ...props }) => {
	const { classes } = useCustomStyles();
	const link = useMemo(() => {
		const linkContent: {
			accoId?: string;
			reviewId?: string;
			photoId?: string;
		} = {};

		if (props.type === 'image') {
			if (props.accommodation) {
				Object.assign(linkContent, {
					accoId: props.accommodation.id,
					photoId: props.image.id,
				});
			} else {
				Object.assign(linkContent, {
					photoId: props.image.id,
				});
			}
		} else if (props.type === 'review') {
			if (props.accommodation) {
				Object.assign(linkContent, {
					accoId: props.accommodation.id,
					reviewId: props.review.heliosId,
				});
			} else {
				Object.assign(linkContent, {
					reviewId: props.review.heliosId,
				});
			}
		}
		const linkObject = new URL('https://cloud.mail.zoover.com/review-rapporteren');
		Object.entries(linkContent).forEach(([key, value]) => linkObject.searchParams.append(key, value));
		return linkObject.toString();
	}, [props]);

	if (!link) return null;

	return (
		<Link href={link} title={title} target="_blank" rel="nofollow noreferrer" aria-label={title}>
			<Button
				variant="tertiary"
				leadingIcon="flag"
				size="small"
				aria-label={title}
				className={classes.reportButton}
				asText
			>
				{!iconOnly && title}
			</Button>
		</Link>
	);
};
